import { Color, Spacing } from '@persona-id/design-tokens';
import styled from 'styled-components';

import Tooltip from 'dashboard/components/Tooltip';
import { CheckAttributeMatch } from 'dashboard/models/check';
import Sticker from 'design-system/components/Sticker';
import { Paragraph } from 'design-system/components/Text';
import { FontWeight } from 'design-system/variables/text';
import { CHECK_ATTRIBUTE_MATCH_DISPLAY } from 'lib/constants/check';
import { assertNever } from 'lib/utils/types';

export const PhotoLabel = styled('p')`
  color: ${Color.CoreSlate1000};
  font-weight: ${FontWeight.Medium};
  margin-top: ${Spacing[2]};
`;

export const MatchSticker = ({ match }: { match: CheckAttributeMatch }) => {
  switch (match) {
    case CheckAttributeMatch.Full: {
      return <Sticker variant='success'>{CHECK_ATTRIBUTE_MATCH_DISPLAY[match]}</Sticker>;
    }
    case CheckAttributeMatch.Partial: {
      return <Sticker variant='caution'>{CHECK_ATTRIBUTE_MATCH_DISPLAY[match]}</Sticker>;
    }
    case CheckAttributeMatch.None: {
      return <Sticker variant='danger'>{CHECK_ATTRIBUTE_MATCH_DISPLAY[match]}</Sticker>;
    }
    case CheckAttributeMatch.Missing: {
      return <Sticker variant='basic'>{CHECK_ATTRIBUTE_MATCH_DISPLAY[match]}</Sticker>;
    }
    default:
      return assertNever(match);
  }
};

export const AlphaLabel = () => {
  return (
    <Tooltip
      placement='top'
      trigger='hover'
      tooltip={
        <Paragraph size='sm' style={{ width: '250px' }}>
          This feature is in alpha. Please don&apos;t rely on it for critical checks or automation.
          Manual review is suggested. Please share your feedback with us.
        </Paragraph>
      }
      hideArrow={true}
    >
      <Sticker variant='caution' style={{ marginLeft: `${Spacing[1]}` }}>
        ALPHA
      </Sticker>
    </Tooltip>
  );
};

export const BetaLabel = () => {
  return (
    <Tooltip
      placement='top'
      trigger='hover'
      tooltip={
        <Paragraph size='sm' style={{ width: '250px' }}>
          This feature is in beta. Please don&apos;t rely on it for critical checks or automation.
          Manual review is suggested. Please share your feedback with us.
        </Paragraph>
      }
      hideArrow={true}
    >
      <Sticker variant='caution' style={{ marginLeft: `${Spacing[1]}` }}>
        BETA
      </Sticker>
    </Tooltip>
  );
};

export const SunsetLabel = () => {
  return (
    <Tooltip
      placement='top'
      trigger='hover'
      tooltip={
        <Paragraph size='sm' style={{ width: '250px' }}>
          This feature is being sunset. Please reach out to Persona for more info and alternatives.
        </Paragraph>
      }
      hideArrow={true}
    >
      <Sticker variant='caution' style={{ marginLeft: `${Spacing[1]}` }}>
        SUNSET
      </Sticker>
    </Tooltip>
  );
};
